import { routes } from "routes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideAllMenus } from "store/application/application-action";
import { useQuery } from "hooks/useQuery";

import "./styles/Tag.scss";

interface ITagProps {
  title: string;
  isLast?: boolean;
  setSearchInput: (arg: string) => void;
  setCurrentTag: (arg: string[]) => void;
}

export const Tag = ({ title, isLast, setSearchInput, setCurrentTag }: ITagProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const query = useQuery();

  const handleClickSearchItem = () => {
    setSearchInput("");
    // @ts-ignore
    setCurrentTag(prev => {
      if (prev.includes(title)) {
        navigate(routes.multipleTag(prev, query.get("order") ?? undefined, !!query.get("verified")));
        return prev;
      }

      if (prev.length >= 3) {
        return prev;
      }

      navigate(routes.multipleTag([...prev, title], query.get("order") ?? undefined, !!query.get("verified")));
      return [...prev, title];
    });
    document?.getElementById("global-search-input")?.blur();
    dispatch(hideAllMenus());
  };

  const handleClickLastTag = () => {
    navigate(routes.trendingTags());
    setSearchInput("");
    setCurrentTag([]);
    dispatch(hideAllMenus());
  };

  const goTo = isLast ? handleClickLastTag : handleClickSearchItem;

  return (
    <li className="Tag" onClick={goTo}>
      <button aria-label={`${title} tag`}>{title}</button>
    </li>
  );
};
